import { Redirect, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { AuthContainer, SignUp, useAuthRouteBase } from '@fhs/auth';

export default function SignUpPage() {
  const { paths } = useAuthRouteBase();
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href={paths.signIn} />;
  }
  return (
    <>
      <Head>
        <title>Create Account - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <SignUp />
      </AuthContainer>
    </>
  );
}
